import { useState } from 'react';
import { WizardData, WizardStep } from './types';

export const useWizard = <ContextData extends WizardData>(
  steps: WizardStep<ContextData>[],
  initialStep?: string,
  initialData?: ContextData
) => {
  const [wizardState, setWizardState] = useState<{ data: ContextData; currentStep: string }>({
    data: initialData,
    currentStep: initialStep || steps?.[0]?.id,
  });

  return {
    wizardState,
    setWizardState,
    steps,
  };
};
